import { scrollPageToTop } from "./paginationScroll";

/** First products request size */
export const INFINITE_SCROLL_INITIAL_SIZE = 40;
/** Each subsequent request size */
export const INFINITE_SCROLL_PAGE_SIZE = 20;
/** Prefetch the next batch when about this many items remain below the fold */
export const INFINITE_SCROLL_PREFETCH_REMAINING = 10;
/** Approximate product-card height used to convert remaining items → rootMargin */
export const INFINITE_SCROLL_ITEM_HEIGHT_PX = 420;

/** @deprecated Use getInfiniteScrollNextRequest instead */
export function getInfiniteScrollRequest(page) {
  const safePage = Math.max(1, Number(page) || 1);
  if (safePage <= 1) {
    return {
      start: 0,
      offset: INFINITE_SCROLL_INITIAL_SIZE,
      mode: "replace",
    };
  }
  return {
    start: INFINITE_SCROLL_INITIAL_SIZE + (safePage - 2) * INFINITE_SCROLL_PAGE_SIZE,
    offset: INFINITE_SCROLL_PAGE_SIZE,
    mode: "append",
  };
}

export function getInfiniteScrollNextRequest({ apiLoadedCount = 0, isRefresh = false } = {}) {
  if (isRefresh || apiLoadedCount <= 0) {
    return {
      start: 0,
      offset: INFINITE_SCROLL_INITIAL_SIZE,
      mode: "replace",
    };
  }
  return {
    start: apiLoadedCount,
    offset: INFINITE_SCROLL_PAGE_SIZE,
    mode: "append",
  };
}

export function getInfiniteScrollBatchSize(page) {
  const safePage = Math.max(1, Number(page) || 1);
  return safePage <= 1 ? INFINITE_SCROLL_INITIAL_SIZE : INFINITE_SCROLL_PAGE_SIZE;
}

export function getInfiniteScrollRootMargin(
  prefetchRemaining = INFINITE_SCROLL_PREFETCH_REMAINING,
  itemHeightPx = INFINITE_SCROLL_ITEM_HEIGHT_PX
) {
  return `0px 0px ${Math.round(prefetchRemaining * itemHeightPx)}px 0px`;
}

/** Keep loading until the API returns a completely blank batch. */
export function hasMoreInfiniteItems({ lastBatchSize }) {
  return lastBatchSize > 0;
}

export function getInfiniteScrollPrefetchIndex(loadedCount) {
  return Math.max(0, loadedCount - INFINITE_SCROLL_PREFETCH_REMAINING);
}

export function resetInfiniteScrollToTop() {
  scrollPageToTop();
}

export function isNearScrollBottom(prefetchPx = INFINITE_SCROLL_PREFETCH_REMAINING * INFINITE_SCROLL_ITEM_HEIGHT_PX) {
  const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
  const scrollHeight = document.documentElement.scrollHeight || 0;
  return scrollTop + viewportHeight >= scrollHeight - prefetchPx;
}
